import { ETypeEvent } from '../enums/events.enum';
import { EBookingStatus } from '../enums/booking.enum';

export const STATUSES = {
    [EBookingStatus.PENDING]: EBookingStatus.PENDING,
    [EBookingStatus.READY_FOR_PICKUP]: EBookingStatus.READY_FOR_PICKUP,
    [EBookingStatus.ARRIVED_AT_PICKUP]: EBookingStatus.ARRIVED_AT_PICKUP,
    [EBookingStatus.WAY_TO_DELIVER]: EBookingStatus.WAY_TO_DELIVER,
    [EBookingStatus.ARRIVED_AT_DELIVERY]: EBookingStatus.ARRIVED_AT_DELIVERY,
    [EBookingStatus.ACCEPTED]: EBookingStatus.ACCEPTED,
    [EBookingStatus.COMPLETED]: EBookingStatus.COMPLETED,
    [EBookingStatus.CANCELLED]: EBookingStatus.CANCELLED,
    [EBookingStatus.CANCELLED_BY_DRIVER]: EBookingStatus.CANCELLED_BY_DRIVER,
    [EBookingStatus.CANCELLED_BY_CUSTOMER]: EBookingStatus.CANCELLED_BY_CUSTOMER,
    [EBookingStatus.CANCELLED_BY_DELIVERY_PROVIDER]: EBookingStatus.CANCELLED_BY_DELIVERY_PROVIDER,
    [EBookingStatus.CANCELLED_BY_ADMIN]: EBookingStatus.CANCELLED_BY_ADMIN,
    [EBookingStatus.CANCELLED_BY_BUSINESS]: EBookingStatus.CANCELLED_BY_BUSINESS,
    [EBookingStatus.ON_HOLD]: EBookingStatus.ON_HOLD,
    [EBookingStatus.NOT_DELIVERED]: EBookingStatus.NOT_DELIVERED,
    [EBookingStatus.RETURNING]: EBookingStatus.RETURNING,
    [EBookingStatus.RETURNED]: EBookingStatus.RETURNED,
    [EBookingStatus.PROVIDER_NOT_FOUND]: EBookingStatus.PROVIDER_NOT_FOUND,
};

export const FINISHED = [
    STATUSES.COMPLETED,
    STATUSES.CANCELLED_BY_ADMIN,
    STATUSES.CANCELLED,
    STATUSES.CANCELLED_BY_DRIVER,
    STATUSES.CANCELLED_BY_BUSINESS,
    STATUSES.CANCELLED_BY_DELIVERY_PROVIDER,
    STATUSES.NOT_DELIVERED,
    STATUSES.RETURNED,
    STATUSES.PROVIDER_NOT_FOUND,
];

export const ENDED: string[] = [
    STATUSES.COMPLETED,
    STATUSES.RETURNED,
];

export const ON_HOLD = [STATUSES.ON_HOLD];

export const PICKING = [STATUSES.ARRIVED_AT_PICKUP, STATUSES.ACCEPTED];
export const DELIVERING = [STATUSES.WAY_TO_DELIVER, STATUSES.ARRIVED_AT_DELIVERY];

export const PERMITTED_UNASSIGN_DRIVER = [
    STATUSES.ACCEPTED,
    STATUSES.ARRIVED_AT_PICKUP,
];

export const EVENTS = {
    [ETypeEvent.NEW_BOOKING]: ETypeEvent.NEW_BOOKING,
    [ETypeEvent.STATUS_UPDATE]: ETypeEvent.STATUS_UPDATE,
    [ETypeEvent.ORDER_UPDATE]: ETypeEvent.ORDER_UPDATE,
    [ETypeEvent.PAYMENT_METHOD_CHANGE]: ETypeEvent.PAYMENT_METHOD_CHANGE,
    [ETypeEvent.SHARE_MY_RIDE]: ETypeEvent.SHARE_MY_RIDE,
    [ETypeEvent.REASSIGN]: ETypeEvent.REASSIGN,
    [ETypeEvent.ASSIGN]: ETypeEvent.ASSIGN,
    [ETypeEvent.SEARCH_START]: ETypeEvent.SEARCH_START,
    [ETypeEvent.MANUAL_HACK]: ETypeEvent.MANUAL_HACK,
    [ETypeEvent.ASSIGN_AUTOMATICALLY]: ETypeEvent.ASSIGN_AUTOMATICALLY,
    [ETypeEvent.END_SEARCH]: ETypeEvent.END_SEARCH,
    [ETypeEvent.RESTART_SEARCH]: ETypeEvent.RESTART_SEARCH,
    [ETypeEvent.REPORT_ISSUE]: ETypeEvent.REPORT_ISSUE,
    [ETypeEvent.UPLOAD_PROOF_OF_DELIVERY]: ETypeEvent.UPLOAD_PROOF_OF_DELIVERY,
    [ETypeEvent.BOOKING_ON_BATCH]: ETypeEvent.BOOKING_ON_BATCH,
    [ETypeEvent.MONITOR_ETA]: ETypeEvent.MONITOR_ETA,
    [ETypeEvent.PICKER_INSIGHT]: ETypeEvent.PICKER_INSIGHT,
    [ETypeEvent.WHATSAPP_TRACKING_READ]: ETypeEvent.WHATSAPP_TRACKING_READ,
};

export const EVENTS_MAPPED = [
    EVENTS.NEW_BOOKING,
    // EVENTS.SEARCH_START,
    EVENTS.ASSIGN,
    EVENTS.STATUS_UPDATE,
    // EVENTS.RESTART_SEARCH,
    // EVENTS.MANUAL_HACK,
    // EVENTS.SHARE_MY_RIDE,
    // EVENTS.REASSIGN,
    // EVENTS.MONITOR_ETA,
    // EVENTS.PICKER_INSIGHT,
];

export const MICRO_EVENTS_MAPPED = [
    STATUSES.ARRIVED_AT_PICKUP,
    STATUSES.WAY_TO_DELIVER,
    STATUSES.ARRIVED_AT_DELIVERY,
    STATUSES.COMPLETED,
    // STATUSES.CANCELLED_BY_ADMIN,
    // STATUSES.CANCELLED_BY_BUSINESS,
    // STATUSES.CANCELLED_BY_DELIVERY_PROVIDER,
    // STATUSES.NOT_DELIVERED,
    // STATUSES.RETURNING,
    // STATUSES.RETURNED,
    // STATUSES.PROVIDER_NOT_FOUND,
];
